import React, { useState } from 'react';
import { Shield, X } from 'lucide-react';
import { useRoute } from '../lib/router';
import { useImpersonation } from '../contexts/ImpersonationContext';

export default function ImpersonationBanner() {
  const { impersonating, end } = useImpersonation();
  const [, navigate] = useRoute();
  const [exiting, setExiting] = useState(false);

  if (!impersonating) return null;

  const exit = async () => {
    if (exiting) return;
    setExiting(true);
    try {
      await end();
      navigate('/superadmin');
      window.location.reload();
    } catch (err) {
      setExiting(false);
      alert(err?.message || 'Could not exit impersonation. Please try again.');
    }
  };

  return (
    <div className="fixed bottom-0 inset-x-0 z-50 flex items-center justify-center gap-3 bg-red-600 text-white text-sm font-medium py-2.5 px-4 shadow-lg">
      <Shield size={14} />
      <span>Viewing as <strong>{impersonating.firm_name || 'Firm'}</strong> — Super Admin mode</span>
      <button
        onClick={exit}
        disabled={exiting}
        className="ml-4 flex items-center gap-1 px-3 py-1 rounded-lg bg-white/20 hover:bg-white/30 transition text-xs disabled:opacity-50"
      >
        <X size={12} /> Exit
      </button>
    </div>
  );
}
